import { render, staticRenderFns } from "./ServiceRecordList.vue?vue&type=template&id=558a4b5f&scoped=true"
import script from "./ServiceRecordList.vue?vue&type=script&lang=js"
export * from "./ServiceRecordList.vue?vue&type=script&lang=js"
import style0 from "./ServiceRecordList.vue?vue&type=style&index=0&id=558a4b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558a4b5f",
  null
  
)

export default component.exports